export default __webpack_public_path__ + "static/media/globalnews.796f5aec.png";